import React from 'react';
import styled from 'styled-components';
import useCompleteTheLook from '../../../cart/hooks/useCompleteTheLook';
import Product from './Product';

const Wrapper = styled.div`
  margin-top: 15px;
  padding: 0px 40px 40px;

  .product-container {
    max-width: 220px;
    margin: 0 auto;
  }
`;

function ThePerfectMatch({ product, source, toggleCart }) {
  const { loading, error, data } = useCompleteTheLook({
    sku: product.sku
  });

  if (loading) return ``;
  if (error) return ``;

  if (data?.completeTheLook.length == 0) return ``;

  const recommendedProduct = data?.completeTheLook[0];

  return (
    <Wrapper>
      <Title>The Perfect Match</Title>
      <div className="product-container">
        <Product
          product={recommendedProduct}
          source={source}
          toggleCart={toggleCart}
        />
      </div>
    </Wrapper>
  );
}

export default ThePerfectMatch;

export const Title = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 32px;
  line-height: 40px;
  color: ${({ theme }) => theme.colors.charcoal};
  opacity: 0.9;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;

  .step {
    color: ${({ theme }) => theme.colors.charcoal};
  }

  @media (max-width: 992px) {
    font-size: 30px;
  }
`;
